module.exports = __webpack_public_path__ + "img/scoreStep_left.a5052ee3.svg";